// extracted by mini-css-extract-plugin
export default {"cr":"cr","cr_qr":"cr_qr","cr_qr_torch":"cr_qr_torch","active":"active","cr_buttons":"cr_buttons"};